module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 5.cd6f88ac.png";